import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  createRef,
  forwardRef,
} from "react";
import { Routes, Route, useNavigate, useParams, Link } from "react-router-dom";
import OrderContex, { OrderContextProvider } from "./../../store/order-context";
import customerServices from "../../services/customerServices";
import measurementServices from "./../../services/measurementServices";

import orderServices from "../../services/orderServices";
import CustomerAdd from "../Customer/CustomerAdd";
import ModalForForms from "../Modals/ModalForForms";
import customer from "./../../Models/customer";
import CustomerMeasurementList from "./../Measurement/CustomerMeasurementList";
import CustomerMeasurement from "./../Measurement/CustomerMeasurement";

import CustomerSingleOrder from "./../Order/CustomerSingleOrder";
import CustomerOrderList from "./../Order/CustomerOrderList";
import CustomerProfile from "./../Customer/CustomerProfile";
import AddCustomerOrder from "../Order/AddCustomerOrder";
import CustomerProfile_emb from "./CustomerProfile_emb";
import CustomerAdd_emb from "./CustomerAdd_emb";

import { useSelector, useDispatch } from "react-redux";
import {
  addCustomerInfo,
  updateCustomerInfoModeStore,
} from "./../../slice/orderSlice";
import useTranslation from "./../../customHooks/translations";

const SingleCustomerComplexPage = () => {
  const translation = useTranslation();
  const dispatch = useDispatch();
  //Get state from store
  const {
    customerStore,
    customerInfoModeStore,
    customerGUIDStore,
    orderStore,
    orderInfoModeStore,
    orderGUIDStore,
    orderItemsWithMeasurementStore,
    isLoadingStore,
  } = useSelector((state) => state.order);

  const [customerGUID, setCustomerGUID] = useState("");
  const [innerPage, setInnerPage] = useState("");
  const [innerPageGUID, setInnerPageGUID] = useState("");
  const [customerMeasurementsAll, setCustomerMeasurementsAll] = useState("");
  const [customer_profile_viewedit_mode, setCustomer_profile_viewedit_mode] =
    useState(3); //initially view mode
  const [customer, setCustomer] = useState();

  const params = useParams();
  let customerid_param = params.cusid === "addnew" ? 0 : params.cusid;
  //** set customer mode */
  // if (params.cusid === "addnew") {
  //   setCustomer_profile_viewedit_mode(1);
  // }
  // let customer_profile_viewedit_mode = 3; // View (edit = 2. add = 1)
  console.log(
    "params: " +
      params.cusid +
      ", " +
      params.innerpage +
      ", " +
      params.innerpageid
  );
  // setCustomerGUID(params.cusid);
  // if (params.innerpage) {
  //   setInnerPage(params.innerpage);
  // }
  // if (params.innerpageid) {
  //   setInnerPageGUID(params.innerpageid);
  // }

  //(**) Get customer

  useEffect(() => {
    //**(1) Get single Customer  */
    async function fetchSingleCustomerData() {
      try {
        // alert(
        //   "called api-> cusotmer id param : customerid_param :- " +
        //     customerid_param
        // );
        // debugger;
        let customerSearched = await customerServices.searchByCustomerGUID(
          // params.cusid || params.cusid === "addnew" ? 0 : params.cusid
          customerid_param
        );
        // alert("api coall done...");
        // debugger;

        if (
          customerSearched &&
          customerSearched !== "undefined" &&
          customerSearched !== null
        ) {
          // alert("inside ... done...");
          // debugger;
          dispatch(addCustomerInfo(customerSearched));
          dispatch(updateCustomerInfoModeStore(3));
        }

        // debugger;

        // alert("called api done - customer-name: " + customerStore?.customerID);
        // console.log("customerSearched : " + customerStore?.name);
      } catch (e) {
        console.error(e);
      }
    }
    // debugger;
    fetchSingleCustomerData();
    //  debugger;

    //**(2) Get all Customer Measurements */
    async function fetchAllCustomerMeasurements() {
      try {
        // alert("called api");
        let customerAllMeasurements =
          await measurementServices.getAllCustomerMeasurementsByCustomerGUID(
            // params.cusid
            customerid_param
          );
        setCustomerMeasurementsAll(
          customerAllMeasurements ? customerAllMeasurements : []
        );
        // alert("called api done" + customerSearched);
        console.log("measurement searched : " + customerAllMeasurements.length);
      } catch (e) {
        console.error(e);
      }
    }

    fetchAllCustomerMeasurements();
  }, [params.cusid]);

  const isValidChildFormInputs = (values) => {
    // alert("isValidChildFormInputs at parent");
    console.log("isValidChildFormInputs value : " + values);
  };

  //******   Customer add/Edit */
  const changeMode_customer_addview = (modeno) => {
    try {
      //alert("indexNo, modeno :" + modeno);
      dispatch(updateCustomerInfoModeStore(modeno));
    } catch (e) {
      console.error(e);
    }
  };

  const savedCustomer = (customerSavedAtDB) => {
    dispatch(addCustomerInfo(customerSavedAtDB));
    dispatch(updateCustomerInfoModeStore(3));
    console.log("customerSavedAtDB data (parent)  ====>", customerSavedAtDB);
  };

  const date = new Date();
  // const futureDate = date.getDate() + 3;
  // date.setDate(futureDate);
  const defaultValue = date.toLocaleDateString("en-CA");

  const clearCustomerInfo = () => {
    console.log("clear customer info...");
    dispatch(addCustomerInfo(null));
    // changeMode_customer_addview(0);
  };

  return (
    <Fragment>
      {/* <div style={{ width: '100%', textAlign: 'center', fontWeight: 'bold', color: 'skyblue' }}>
        {translation.Customer_Information}
      </div> */}

      <OrderContextProvider>
        <div className="card-body">
          {/* (Part - 1) Top - Customer detail */}
          {/* <CustomerAdd
          isValidChildFormInputs={isValidChildFormInputs}
          AddCustomerToDB={AddCustomerToDB}
          ref={childSubmitButton}
        />{" "} */}

          {((!customerStore ||
            customerStore?.customerID === "undefined" ||
            customerStore?.customerID === 0) && (
            <CustomerAdd_emb
              customer={{
                name: "",
                cellNo: "",
                alternetPhone: "",
                email: "",
                address: "",
                registeredDate: defaultValue,
              }}
              mode={1}
              changeMode={changeMode_customer_addview}
              savedCustomer={savedCustomer}
              clearCustomerInfo={clearCustomerInfo}
            />
          )) ||
            (customerInfoModeStore === 2 && (
              <CustomerAdd_emb
                customer={customerStore}
                mode={2}
                changeMode={changeMode_customer_addview}
                savedCustomer={savedCustomer}
                clearCustomerInfo={clearCustomerInfo}
              />
            )) ||
            (customerInfoModeStore === 3 && (
              <CustomerProfile_emb
                customer={customerStore}
                mode={3}
                changeMode={changeMode_customer_addview}
                clearCustomerInfo={clearCustomerInfo}
              />
            ))}
          {/* {customer ? (
          customer_profile_viewedit_mode == 3 ? (
            <CustomerProfile_emb customer={customer} />
          ) : (
            <CustomerAdd_emb customer={customer} />
          )
        ) : (
          <CustomerAdd_emb customer={customer} />
        )} */}
          <hr />
          <div className="email-left-box left-bar-email">
            <h5 className="mt-5 m-b-10">Order</h5>
            <div className="list-group mail-list">
              <Link
                className="fa fa-briefcase f-s-14 mr-2"
                to={`/Customer/${params.cusid}/Order/AddNew`}
              >
                Add New
              </Link>
              <Link
                className="fa fa-sellsy f-s-14 mr-2"
                to={`/Customer/${params.cusid}/Order`}
              >
                ALL
              </Link>

              {/* <Link to={`/${this.props.testvalue}?backUrl=${backUrl}`} /> */}
            </div>

            <h5 className="mt-5 m-b-10">Measurement</h5>
            <div className="list-group mail-list">
              {/* <a className="list-group-item border-0">
              <span className="fa fa-briefcase f-s-14 mr-2"></span>Add New
            </a>
            <a className="list-group-item border-0">
              <span className="fa fa-sellsy f-s-14 mr-2"></span>All
            </a> */}
              <Link
                className="fa fa-briefcase f-s-14 mr-2"
                to={`/Customer/${params.cusid}/Measurement/AddNew`}
              >
                Add New
              </Link>
              <Link
                className="fa fa-sellsy f-s-14 mr-2"
                to={`/Customer/${params.cusid}/Measurement`}
              >
                ALL
              </Link>

              {/* <Link to={`/${this.props.testvalue}?backUrl=${backUrl}`} /> */}
            </div>
          </div>
          <div className="email-right-box right-bar-email">
            {params.innerpage === undefined &&
              params.innerpageid === undefined && <CustomerProfile />}

            {params.innerpage === "Order" &&
              params.innerpageid === undefined && (
                <CustomerOrderList customerGUID={params.cusid} />
              )}
            {params.innerpage === "Order" &&
              params.innerpageid !== undefined &&
              params.innerpageid === "AddNew" && (
                <AddCustomerOrder orderGUID={""} customerGUID={params.cusid} />
              )}
            {params.innerpage === "Order" &&
              params.innerpageid !== undefined &&
              params.innerpageid !== "AddNew" && (
                <AddCustomerOrder
                  // isCopy={params.innerpage2}
                  isCopy={false}
                  orderGUID={params.innerpageid}
                  customerGUID={
                    params.cusid === "addnew"
                      ? customer
                        ? customer.customerGUID
                        : 0
                      : params.cusid
                  }
                />
              )}

            {params.innerpage === "OrderCopy" &&
              params.innerpageid !== undefined &&
              params.innerpageid !== "AddNew" && (
                <AddCustomerOrder
                  // isCopy={params.innerpage2}
                  isCopy={true}
                  orderGUID={params.innerpageid}
                  customerGUID={
                    params.cusid === "addnew"
                      ? customer
                        ? customer.customerGUID
                        : 0
                      : params.cusid
                  }
                />
              )}

            {params.innerpage === "Measurement" &&
              params.innerpageid === undefined && (
                <CustomerMeasurementList customerGUID={params.cusid} />
              )}

            {params.innerpage === "Measurement" &&
              params.innerpageid === "AddNew" && (
                <CustomerMeasurement customerGUID={params.cusid} />
              )}
          </div>
        </div>
      </OrderContextProvider>
    </Fragment>
  );
};

export default SingleCustomerComplexPage;
